import { Injectable } from '@angular/core';

import { StakeConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

@Injectable()
export default class BetslipStakeConfigurationService {
    private _stakeValues: number[];
    private _maxStake: number | null;

    constructor(stakeConfig: StakeConfig, userService: UserService) {
        this._stakeValues = stakeConfig.stakeValuesByCurrency[userService.currency.toLowerCase()] || stakeConfig.stakeValuesByCurrency.default;

        if (stakeConfig.maxStakeByCurrency) {
            this._maxStake = stakeConfig.maxStakeByCurrency[userService.currency.toLowerCase()] || stakeConfig.maxStakeByCurrency.default;
        } else {
            this._maxStake = null;
        }
    }

    get stakeValues(): number[] {
        return this._stakeValues;
    }

    get maxStake(): number | null {
        return this._maxStake;
    }
}
